<template>
  <v-container grid-list-md>
    <div class="pwc-logo" :style="cThankslogoStyle">
      <img src="../../assets/logo.png">
    </div>
    <v-layout v-if="videoList.length > 0" row wrap class="video-list">
      <v-flex v-for="(item, i) in videoList" :key="`3${i}`" xs12 md6 xl3 class="video-flex">
        <v-card color="secondary" style="cursor: pointer;">
          <v-img :src="item.courseCover" aspect-ratio="1.7" @click="goToDetail(item)" />
          <v-card-title primary-title>
            <div style="width: 100%; line-height: 30px" @click="goToDetail(item)">
              <div class="video-title" :class="isMobile? '': 'video-label'">
                <h2 :title="item.courseName">{{ item.courseName }}</h2>
              </div>
              <!-- <div class="video-time">
                <div>{{ item.courseTime }}</div>
              </div> -->
              <div class="video-title">
                <div>{{ item.teacher }}</div>
                <div>{{ item.courseDate }}</div>
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else row justify-center>
      <div style="font-size: 20px; margin-top: 50px">当前无可观看内容</div>
    </v-layout>
    <v-pagination v-if="false" v-model="page" class="float:right" :length="1" :total-visible="totalVisible" />
  </v-container>
</template>

<script>
import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()
import Actions from '@/constants/action'
import { mapActions } from 'vuex'
import RouterName from '@/constants/route'
const courseType = ['AD', 'AW']
export default {
  name: 'VideoList',
  data() {
    return {
      card_text:
        'Lorem ipsum dolor sit amet, brute iriure accusata ne mea. Te duo agam libris, utroque quaestio accommodare no qui.',
      page: 1,
      videoList: [],
      courseType: this.$route.query.courseType,
      isMobile: isMobile
    }
  },
  computed: {
    cThankslogoStyle() {
      if (!isMobile) {
        return {
          'background-color': 'transparent'
        }
      }
      return {}
    },
    totalVisible() {
      return isMobile ? 5 : 7
    }
  },
  async mounted() {
    if (courseType.includes(this.courseType)) {
      this.videoList = []
    } else { // YP
      const res = await this.getVideoList({ courseType: this.courseType })
      if (res.resultCode === '0') {
        this.videoList = res.data
      }
    }
  },
  methods: {
    ...mapActions({
      getVideoList: Actions.GET_VIDEO_LIST,
      saveVideo: Actions.SAVE_VIDEO
    }),
    goToDetail(video) {
      this.saveVideo(video)
      localStorage.setItem('_video_', JSON.stringify(video))
      this.$router.push({ name: RouterName.videoDetail, params: { courseId: video.courseId }})
    }
  }
}
</script>

<style lang="scss">
.pwc-logo {
  margin: auto;
  box-sizing: border-box;
  position: relative;
  height: auto;
  width: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  max-width: 640px;
  padding-top: 36px;
  margin-bottom: 20px;
  img {
    width: 90%;
  }
}
.video-list {
  font-size: 16px;
  .video-flex {
    padding: 12px !important;
  }
}
.v-pagination__navigation .v-icon {
  font-size: 14px;
}
.v-pagination__navigation {
  width: 34px;
  height: 34px;
}
.v-pagination__item {
  margin: 2px !important;
}
.primary {
  background-color: rgb(208, 74, 2) !important;
  border-color: rgb(208, 74, 2) !important;
}
.v-pagination__more {
  font-size: 14px;
  height: 14px;
  width: 14px;
}
.video-time {
  display: flex;
  justify-content: flex-end;
  color: rgb(208, 74, 2);
  font-weight: 800;
}
.video-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.video-label {
  overflow: hidden;  // 超出的文本隐藏
  text-overflow: ellipsis; // 溢出用省略号显示
  white-space: nowrap; // 溢出不换行
  display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示。
  -webkit-line-clamp: 2; // 这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数
}
</style>
